import React, { useState, useEffect, useRef } from 'react';

import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';

import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';

import AllPlanning from './Components/AllPlanning.js';
import DriverPlanning from './Components/DriverPlanning.js'; 
import ExportPlanning from './Components/ExportPlanning.js'; 
import ImportPlanning from './Components/ImportPlanning.js';


const Planning = () => {
  
  const initialTab = localStorage.getItem("Ftab_planning") || 'allplanning';
  const [selectedButton, setSelectedButton] = useState(initialTab);
 
  
 useEffect(() => {
    setSelectedButton(initialTab);
  }, [initialTab]);
  // console.log('555', selectedButton);
  const handleButtonClick = (button) => {
    setSelectedButton(button);
    localStorage.setItem('Ftab_planning', button);
    localStorage.removeItem('link_mawb')
  };

  return (
    <>
      <div className="">
        <Header page_type='fsm' logo_url='/ForwarderShipments/Planning' />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel rounded">
            <div className="mainTab">
              <TopMenu module='FSHPMNGR' />
              <div className="">
                <div className="allcontent-fl">
                  <div className='d-flex justify-content-between mb-3'>
                    <div>
                      <button className={selectedButton === 'allplanning' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('allplanning')}>
                        <img src={selectedButton === 'allplanning' ? AssetsIconw : AssetsIcon} /> <span>All Planning</span>
                      </button>
                      <button className={selectedButton === 'exportplanning' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('exportplanning')}>
                        <img src={selectedButton === 'exportplanning' ? AssetsIconw : AssetsIcon} /> <span>Export Planning</span>
                      </button>
                      <button className={selectedButton === 'importplanning' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('importplanning')}>
                        <img src={selectedButton === 'importplanning' ? AssetsIconw : AssetsIcon} /> <span>Import Planning</span>
                      </button>
                      <button className={selectedButton === 'driverplanning' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('driverplanning')}>
                        <img src={selectedButton === 'driverplanning' ? AssetsIconw : AssetsIcon} /> <span>Driver Planning</span>
                      </button>
                    </div>
                    <div className='search'>
                      <div className="form-group has-search">

                        {/* <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                /> */}
                      </div>
                    </div>
                  </div>
                  <div className="lcontent">
                    {selectedButton === 'allplanning' && <AllPlanning />}
                    {selectedButton === 'exportplanning' && <ExportPlanning />}
                    {selectedButton === 'importplanning' && <ImportPlanning />}
                    {selectedButton === 'driverplanning' && <DriverPlanning />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Planning